export default __webpack_public_path__ + "static/media/05-ADITYA TALAWAR.b55b083f.jpg";